import React from 'react';
import Label from '~/reusable-components/inputs/Label';
import Textarea from '~/reusable-components/inputs/Textarea';

interface RequestInputProps {
  label: string;
  placeholder: string;
  defaultValue?: string;
}

function RequestInput({ label, placeholder, defaultValue }: RequestInputProps) {
  return (
    <>
      <Label>{label}</Label>
      <Textarea
        placeholder={placeholder}
        name="request"
        required
        defaultValue={defaultValue}
      />
    </>
  );
}

export default RequestInput;
